export default __webpack_public_path__ + "static/media/nft11.043950cd.png";